import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import { getTransactionReceipt } from "containers/services/services";
import { useAppContext } from "utils/context";
import configs from "utils/globals";
import { getUserData } from "containers/services/data.transformers";
import ReceiptSharing from "components/receiptSharing";
import OperationShare from "./components/share";
import OperationsContent from "./components/content";
import OperationsHeader from "./components/header";
import OperationsLoading from "./components/loading";
import { digitsEnToFa } from "@persian-tools/persian-tools";

import { ReactComponent as BankPattern } from "assets/images/bank-card/bank-receipt-pattern.svg";

import "./index.scss";
import { WebengageGeneralButtonEvent } from "containers/services/events.data";

const OperationsReceipt = () => {
  const elementRef = useRef();
  const { instance } = useAppContext();
  const params = useParams();

  const [receipt, setReceipt] = useState({});
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const handleReceiptDetails = async () => {
    const result = await getTransactionReceipt(instance, params?.id);
    if (result) setReceipt(result);
    WebengageGeneralButtonEvent(
      "bank-button-transfer-finished",
      "",
      "button",
      { Status: result?.status === "DONE" ? "success" : "failed" }
    );
    setLoading(false);
  };

  const getUser = async () => {
    const userData = await getUserData();
    setUser(userData);
  };

  useMemo(async () => {
    await getUser();
  }, []);

  const handleDownloadImage = async () => {
    configs.base64toFile({
      filename: `${configs.converToPersianDateTime(receipt?.updated_at)}.png`,
      isDownloadFail: true,
    });
  };

  const handleGenerateSourceAccount = (options = {}) => {
    const { isSeparateAccountNumber = true } = options;
    const { account, destination_address, transaction_type } = receipt;
    if (`${transaction_type}`.toLowerCase() === "card") {
      const newNumber = `${account?.card_number}`
        .split("")
        .map((el, index) => (index > 5 && index < 12 ? "*" : el))
        .join("")
        .match(/.{1,4}/g)
        .join(" ");
      const cardNumber = digitsEnToFa(newNumber);
      const newAddress = `${destination_address}`
        .split("")
        .map((el, index) => (index > 5 && index < 12 ? "*" : el))
        .join("")
        .match(/.{1,4}/g)
        .join(" ");
      const destinationAddress = digitsEnToFa(newAddress);

      return [cardNumber, destinationAddress];
    }

    const newNumber = isSeparateAccountNumber
      ? `${account?.account_number}`.replaceAll("/", " / ")
      : `${account?.account_number}`;
    const accountNumber = digitsEnToFa(newNumber);

    const destinationAddress = digitsEnToFa(`${destination_address}`);
    return [accountNumber, destinationAddress];
  };

  const handleShareWithText = () => {
    const { amount, bank_reference, destination_title, updated_at } =
      receipt ?? {};

    const newAmount = [
      "مبلغ:",
      `${digitsEnToFa(`${amount?.toLocaleString()}`)}`,
      "ریال",
    ];
    const text = [
      `تاریخ و زمان: ${digitsEnToFa(
        `${configs.converToPersianDateTime(updated_at)}`
      )}`,
      newAmount.join(" "),
      `انتقال دهنده: ${user?.name}`,
      `کارت مبدا: ${handleGenerateSourceAccount({ isSeparateAccountNumber: false })[0]
      }`,
      `دریافت کننده: ${destination_title}`,
      `کارت مقصد: ${handleGenerateSourceAccount()[1]}`,
      `شماره پیگیری: ${digitsEnToFa(`${bank_reference}`)}`,
    ];

    return {
      title: "",
      text: text.join("\n"),
    };
  };

  const handleShareWithImage = () => {
    configs.base64toFile({
      filename: `${configs.converToPersianDateTime(receipt.updated_at)}.png`,
    });
  };

  useEffect(() => {
    handleReceiptDetails();
  }, []);

  const title =
    `${receipt?.transaction_type}`.toLowerCase() === "card"
      ? "card-to-card"
      : "money-transfer";

  return (
    <div className="relative">
      <div className="fixed left-1/2 -translate-x-1/2 translate-y-0 max-w-3xl m-auto h-[100vh] pb-[87px] bg-gray--12 w-full overflow-auto z-10">
        {loading ? (
          <OperationsLoading />
        ) : (
          <>
            <OperationsHeader title={title} />
            <div className="w-[100% - 20px] bg-cover bg-[url('https://cdn.firouzeh.com/public/bank-resid-pattern.png')] bg-center-top bg-no-repeat rounded-xl shadow-xl mx-5 py-5 ">
              <OperationsContent {...receipt} user={user} className="w-full" />
              <ReceiptSharing
                shareWithImageText={handleShareWithText()}
                onDownloadImage={handleDownloadImage}
                onShareImage={handleShareWithImage}
              />
            </div>
          </>
        )}
      </div>
      <div className="fixed left-1/2 -translate-x-1/2 translate-y-0 overflow-hidden rounded-lg top-[0] w-[420px] h-[832px] ">
        <div
          ref={elementRef}
          id="content"
          className="w-[420px] h-[832px] relative font-dana px-5 py-[78px] z-10 flex justify-center items-center "
        >
          {/* https://cdn.firouzeh.com/public/bank-receipt-pattern.png' */}
          <BankPattern className="absolute right-0 top-0 w-full h-[832px] " />
          <OperationShare
            user={user}
            {...receipt}
            onGenerateSourceAccount={handleGenerateSourceAccount}
          />
        </div>
      </div>
    </div>
  );
};

export default OperationsReceipt;
